import axios from 'axios'

const putBanners = async (banner) => {

  const token = JSON.parse(localStorage.getItem('Usuario'))?.token

    try {
      const response = await axios({
        method: 'put',
        url: `${process.env.REACT_APP_BACKEND_URL}/bannerPub`,
        data: banner,
        headers: {
          authorization: token
        },
        responseType: 'json'
      })
      return response
    } catch (error) {
      console.log(error)    
    }
  }
  
  export default putBanners